import React from 'react';
import SimpleHeader from './SimpleHeader';
import SimpleChart from './SimpleChart';
import SimpleRanking from './SimpleRanking';

/**
 * Renderiza el bloque SimpleAnalyticsView de SCAPP V2.
 *
 * @param {object} props
 * @param {object} props.v - Modelo de presentación y callbacks del panel.
 * @returns {React.ReactNode} Bloque visual sin estado local.
 */
export default function SimpleAnalyticsView({
  v
}) {
  return v.viewSimple ? React.createElement(React.Fragment, null, v.text("\n  "), React.createElement("div", {
    style: {
      "flex": "1",
      "minHeight": "0",
      "display": "grid",
      "gridTemplateRows": "auto minmax(0,1fr) 18.518519vh",
      "gap": "1.111111vh"
    }
  }, v.text("\n    "), React.createElement(SimpleHeader, {
    v
  }), v.text("\n    "), React.createElement(SimpleChart, {
    v
  }), v.text("\n    "), React.createElement(SimpleRanking, {
    v
  }), v.text("\n  ")), v.text("\n  ")) : null;
}
